import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Roles } from '../../models/roles';
import { AppService } from '../../services/app.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/users.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  readonly isDevelopment =
    environment.appEnv === 'development' && environment.enableDevBadge;

  userMenuItems: MenuItem[] = [];

  constructor(
    public authService: AuthService,
    public appService: AppService,
    public userService: UserService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.buildUserMenuItems();
  }

  buildUserMenuItems(): void {
    this.userMenuItems = [
      {
        label: 'Configuración',
        icon: 'pi pi-cog',
        command: () => this.router.navigateByUrl('/settings'),
      },
    ];

    if (this.canCreateSupportTicket()) {
      this.userMenuItems.push({
        label: 'Crear ticket de soporte',
        icon: 'pi pi-question-circle',
        command: () => this.openSupportModal(),
      });
    }

    this.userMenuItems.push(
      {
        separator: true,
      },
      {
        label: 'Cerrar sesión',
        icon: 'pi pi-sign-out',
        command: () => this.logout(),
      },
    );
  }

  logout(): void {
    this.authService.logOut();
  }

  canCreateSupportTicket(): boolean {
    return this.authService.role !== Roles.Admin;
  }

  openSupportModal(): void {
    this.appService.triggerCreateSupportTicket(true);
  }
}
